module.exports = __webpack_public_path__ + "img/no-image.23d9c3da.jpg";